import LoaderModal from "../../modal/loader-modal"
import CommanErrorModal from "../../modal/common-error-modal";

const QuickPricerModals = ({
  loading,
  commonErrorModalVisible,
  commonErrorMessage,
  commonErrorCode,
  commonErrorTitle,
  handleCloseCommonErrorModal,
}) => {
  return (
    <>
      <LoaderModal open={loading} />
      <CommanErrorModal
        isOpen={commonErrorModalVisible}
        onClose={handleCloseCommonErrorModal}
        title={commonErrorTitle || "Something went wrong"}
        message={commonErrorMessage}
        errorCode={commonErrorCode}
      />
    </>
  );
};

export default QuickPricerModals;